import React, { useState } from "react";
import { track } from "../../../../../analytics";
import "./TarifCustomCard.scss";
import MyButton from "../../../../../UI/MyButton/MyButton";
import ConnectModal from "../../../../General/Components/ConnectModal/ConnectModal";

const TarifCustomCard = ({ img, title, subTitle, data, price, longText, show, dataText, iptv }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const showModal = () => {
    track("cta_click", {
      place: iptv ? "iptv" : "additional",
      label: "Подключить",
      tariff_name: title || "",
      category: iptv ? "iptv" : "additional",
    });
    show(true);
  };

  // IPTV "Базовый" — только кнопка "Подключить" с модалкой, без "Подробнее"
  if (iptv === undefined || iptv === false) {
    // обычная карточка (Дополнительно и др.) — без изменений
    return (
      <div className="tarifCustomCard_block">
        <img src={img} alt="" />
        <div className="tarifCustomCard_item">
          <div className="tarifCustomCardTop_text">
            <h2>{title}</h2>
            <p>{subTitle}</p>
            <p>{dataText}</p>
          </div>
          <h3>{data}</h3>
          <div className="tarifCustomCardBottom_text">
            <h2>
              {price} <span>{longText}</span>
            </h2>
            <div className="tarifCustomCardBottom_btn">
              <MyButton name={"Подключить"} width={"50%"} height={"44px"} size={"16px"} data={showModal} />
              <MyButton name={"Подробнее"} width={"50%"} height={"44px"} size={"16px"} grey={true} data={showModal} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // IPTV карточка — только "Подключить", открывает ConnectModal
  return (
    <div className="tarifCustomCard_block">
      <img src={img} alt="" />
      <div className="tarifCustomCard_item">
        <div className="tarifCustomCardTop_text">
          <h2>{title}</h2>
          <p>{subTitle}</p>
          <p>{dataText}</p>
        </div>
        <h3>{data}</h3>
        <div className="tarifCustomCardBottom_text">
          <h2>
            {price} <span>{longText}</span>
          </h2>
          <div className="tarifCustomCardBottom_btn">
            <MyButton
              name={"Подключить"}
              width={"100%"}
              height={"44px"}
              size={"16px"}
              data={() => {
                track("cta_click", {
                  place: "iptv",
                  label: "Подключить",
                  tariff_name: title || "",
                  category: "iptv",
                });
                setModalOpen(true);
              }}
            />
          </div>
        </div>
      </div>

      <ConnectModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        serviceName={`IP TV ${title}`}
        interestedIn={0}
        apiEndpoint="/add_deal_iptv"
      />
    </div>
  );
};

export default TarifCustomCard;